import * as React from 'react';
import { memo } from 'react';

import { LayoutTriggers } from 'defs/layout';
import { delayed } from 'lib/Job';

import noop from 'helper/noop';

import ProgramFinish, { ProgramFinishProps } from 'components/molecules/Program/ProgramFinish';
import ProgramStats, { ProgramStatsPropsType } from 'components/molecules/Program/ProgramStats';
import ProgramSuccess, { ProgramSuccessProps } from 'components/molecules/Program/ProgramSuccess';
import { CoachIsEnumType } from '../../CoachSelector/CoachSelector';

export type ProgramSummaryPropsType = ProgramSuccessProps &
	ProgramFinishProps &
	ProgramStatsPropsType & {
		doLockBody: (trigger?: string) => void;
		coach: CoachIsEnumType;
	};

export class ProgramSummary extends React.Component<ProgramSummaryPropsType> {
	public static displayName = 'ProgramSummary';
	public static defaultProps = {
		doLockBody: noop,
		coach: 'LEO',
	};

	public componentDidMount() {
		delayed(() => {
			this.props.doLockBody(LayoutTriggers.ProgramSummary);
		}, 1000);
	}

	public render() {
		return (
			<React.Fragment>
				<ProgramFinish {...this.props} />
				<ProgramStats {...this.props} />
				<ProgramSuccess {...this.props} />
			</React.Fragment>
		);
	}
}

export default memo(ProgramSummary);
